import { AdminApi } from './apis';
import { iBinderFetch } from './iBinderFetch';

export const ImpersonateUser = async ({ userId }) => {
  await CleanupImpersonation();
  const tenantFetch = iBinderFetch({ tenantId: null });

  const response = await tenantFetch(`${AdminApi}/impersonate/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ targetUserId: userId })
  });

  const TheJson: any = await response.json();

  console.log('TheJson', TheJson);
  if (response.status === 200 && TheJson.impersonationToken) {
    await localStorage.setItem(
      'impersonation_token',
      TheJson.impersonationToken
    );
  }
  return TheJson;
};

export const CleanupImpersonation = async () => {
  localStorage.removeItem('impersonation_token');
};
